import { getSupportCenterDomain } from '@va/dashboard/selectors/customization';
import { SettingsHeading } from '@va/dashboard/ui/pages';
import { GlobeIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { contributorRole } from '@va/standalone/shared/selectors';
import { InputWithSubsection } from '@va/ui/design-system';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';
import { EmailListItems } from '../components';
import { ErrorAlertsToggle } from './ErrorAlertsToggle';
import useErrorAlertsPreferences from './useErrorAlertsPreferences';

export const ErrorAlerts = () => {
  const translate = useTranslate();
  const supportCenterDomain = useSelector(getSupportCenterDomain);
  const {
    allEmails,
    emailAddress,
    onChangeEmail,
    isSaveEmailButtonDisabled,
    isAlarmingBehaviorSettingsLoading,
    isAlarmingBehaviorSettingsUpdateSucceeded,
    formError,
    onSaveEmail,
    onRemoveEmail,
    onResendEmailConfirmation,
  } = useErrorAlertsPreferences();

  const isContributor = useSelector(contributorRole);

  const cardHeading = (
    <SettingsHeading
      title={translate('form.errorAlerts.title')}
      subText={translate('form.errorAlerts.desc')}
      tooltip={translate('card.errorAlerts.tooltip', { supportCenterDomain })}
    />
  );

  if (isAlarmingBehaviorSettingsLoading) {
    return (
      <div className='gap-18px'>
        {cardHeading}
        <div className='flex flex-col gap-2'>
          <Skeleton className='h-72 rounded-18' />
          <Skeleton className='h-72 rounded-18' />
          <Skeleton className='h-72 rounded-18' />
          <Skeleton className='h-72 rounded-18' />
        </div>
      </div>
    );
  }

  return (
    <div className='flex flex-col gap-18px'>
      {cardHeading}
      <div className='flex flex-col gap-3'>
        <InputWithSubsection
          disabled={isContributor}
          infoTooltip={isContributor ? translate('tooltips.contributorRole') : undefined}
          isLoading={isSaveEmailButtonDisabled}
          onSubmit={onSaveEmail}
          icon={<GlobeIcon color='#3C3C3C' />}
          successSubmit={isAlarmingBehaviorSettingsUpdateSucceeded}
          inputProps={{
            value: emailAddress,
            onChange: onChangeEmail,
            placeholder: translate('card.errorAlerts.addEmail.placeholder'),
            name: 'emailAddressInput',
            label: translate('card.errorAlerts.addEmail.label'),
          }}
          error={formError}
          listItemWrapperClass='!grid-cols-1'
          onRemove={() => {}}
          listItems={[]}
          itemsLabel={''}
        >
          <EmailListItems
            isLoading={isAlarmingBehaviorSettingsLoading}
            listItems={allEmails ?? []}
            onRemoveClick={onRemoveEmail}
            onResendEmailConfirmation={onResendEmailConfirmation}
          />
        </InputWithSubsection>

        <ErrorAlertsToggle />
      </div>
    </div>
  );
};
